export class DataSettings<V = string, F = string> {
  constructor(
    public readonly valueKey: V,
    public readonly filterKey: F,
    public readonly name: string,
    public readonly color: string,
  ) {}
}
